import UbahRAB from './UbahRAB';

export default UbahRAB;
